import cn from 'classnames';
import map from 'lodash/map';
import times from 'lodash/times';
import parse from 'html-react-parser';
import SVG from 'react-inlinesvg';
import { useEffect, useRef, useState } from 'react';
import { gsap } from 'gsap';
import styles from './Marquee.module.scss';

export const Marquee = ({ lines, href, theme, onClick }) => {
    const [ isVisible, setIsVisible ] = useState(false)

    const marqueeParentRef = useRef(null)
    const tl = useRef(null)
    const lineRef = useRef([])

    const handlerClick = (event) => {
        event.preventDefault();

        if(href) {
            window.open(href, '_blank');
        }

        if(onClick) {
            onClick?.();
        }
    }

    useEffect(() => {
        const marqueeParent = marqueeParentRef.current

        const observer = new IntersectionObserver(([entry]) => {
            setIsVisible(entry.isIntersecting)
        })

        if(marqueeParent) observer.observe(marqueeParent)

        tl.current = gsap.timeline({
            paused: true,
            defaults: {
                ease: 'linear',
            }
        })

        lineRef.current.forEach((el, index) => {
            gsap.set(el.children, { clearProps: 'all' })

            tl.current.to(el.children, {
                xPercent: !index % 2 ? -100 : 100,
                duration: el.textContent.trim().length / 12,
                repeat: -1
            }, '')
        })

        return () => {
            tl.current.kill()
            if(marqueeParent) observer.unobserve(marqueeParent)
        }
    }, [lines])

    useEffect(() => {
        isVisible ? tl.current.resume() : tl.current.pause()
    }, [isVisible])

    return (
        <div
            className={ cn(
                styles.marquee, {
                    [styles[theme]]: theme
                }
            ) }
            onMouseEnter={ () => tl.current.timeScale(.33) }
            onMouseLeave={ () => tl.current.timeScale(1) }
            ref={ marqueeParentRef }
            style={ {
                cursor: (href || onClick) && 'pointer'
            } }
            onClick={ handlerClick }
        >
        { map(lines, (line, index) => (
            <div
                key={ 'line-'+index }
                className={ styles.line }
                ref={ (el) => lineRef.current[index] = el }
            >
            { map(times(6), (_, j) => (
                <span
                    key={ `line-${index} text-${j}` }
                >
                    { parse(line.text) }
                    <SVG className={ styles.icon } src={ `/img/icons/icon-marquee-${ line.icon }.svg` } />
                </span>
            )) }
            </div>
        )) }
        </div>
    )
}
